import { initializeApp, provideFirebaseApp} from '@angular/fire/app';
import { environment } from '../../environments/environment';


export const firebaseApp = provideFirebaseApp(() => initializeApp(environment.firebase.config));